import React from "react";
import DrumWidthSelection from "./drumWidthSelection";
import DrumSurfaceSelection from "./drumSurfaceSelection";
import MotorTypes from "./mototType";
import RotationDirection from "./rotationDirection";
import MotorLayout from "./motorLayout";
import PressureRoller from "./pressureRoller";
import RopeEndControl from "./ropeEndControl";
import PaintFinish from "./paintFinish";
import WireRope from "./wireRope";
import Fasteners from "./fasteners";
import ExternalBrakeRelease from "./externalBrakeRelease";
import ThrottleValve from "./throttleValve";
import LoadMeasuring from "./loadMeasuring";
import Selected from "./selected";
import FooterText from "./footerText";
import StickyBox from "react-sticky-box";

const SelectionAndSelectedContainer = () => (
  <div className="row selectionAndSelectedContainer">
    <div className="col-md-7 col-sm-7 col-xs-12">
      <DrumWidthSelection />
      <DrumSurfaceSelection />
      <MotorTypes />
      <RotationDirection />
      <MotorLayout />
      <PressureRoller />
      <RopeEndControl />
      <LoadMeasuring />
      <PaintFinish />
      <WireRope />
      <Fasteners />
      <ExternalBrakeRelease />
      <ThrottleValve />
      <br />
      {/* <FooterText /> */}
    </div>
    <div className="col-md-5 col-sm-5 col-12">
      <StickyBox offset={30}>
        <Selected />
      </StickyBox>
    </div>
  </div>
);

export default SelectionAndSelectedContainer;



// WEBPACK FOOTER //
// ./src/components/selectionAndSelectedContainer.js